/**
 * GET /api/widget list URL.
 * Backend requires a `filter` query param (400 FILTER_REQUIRED without it).
 */
export const WIDGET_LIST_FILTER = 'all'

export function buildWidgetListUrl(
  baseUrl: string,
  options?: { page?: number; limit?: number; },
): string {
  const base = baseUrl.replace(/\/$/, '')
  const page = options?.page ?? 1
  const limit = options?.limit ?? 100
  const q = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  })
  return `${base}/api/widget?${q.toString()}`
}
